import {useQuery} from '@tanstack/react-query';
import {OhdService} from '../services/ohdService';

export function useMyIncentives(enabled: boolean = true) {
    return useQuery({
        queryKey: ['ohd-my-incentives'],
        queryFn: () => OhdService.getMyIncentives(),
        enabled,
        staleTime: 5 * 60 * 1000,
        // 404 = user isn't OHD-linked. Treat as a soft empty state in the
        // page rather than retrying or surfacing as an error.
        retry: (failureCount, error) => {
            const status = (error as {status?: number; response?: {status?: number}})?.status
                ?? (error as {response?: {status?: number}})?.response?.status;
            if (status === 404 || status === 401 || status === 403) return false;
            return failureCount < 2;
        },
    });
}
